import { ReactNode } from 'react'

export interface DialogTemplate {
    title: string
    image: string
    subtitle: ReactNode
}

export type DialogVariant = 'tiering-faq'

export const dialogTemplates: Record<DialogVariant, DialogTemplate> = {
    'tiering-faq': {
        title: 'LEVEL UP ACHIEVEMENTS',
        image: '/assets/images/info-dialogue/tiering-faq.webp',
        subtitle: (
            <span>
                Master your missions to upgrade <br /> your achievements to a higher tier.
            </span>
        ),
    },
}
